import { createContext, useContext } from 'react';

// Centralised app context — imported by both App.jsx (provider)
// and any component (consumer) without creating a circular dependency.
export const AppContext = createContext();
export const useApp = () => useContext(AppContext);
